import { useVoiceAssistantStore } from '../store/useVoiceAssistantStore';

/**
 * True once the clinician has engaged — empty-state chips should collapse.
 * Heidi’s idle greeting alone must not hide the Figma quick-start cards.
 */
export function useHasVoiceConversation(): boolean {
  return useVoiceAssistantStore((s) =>
    s.timeline.some(
      (entry) =>
        (entry.kind === 'transcript' &&
          entry.role === 'user' &&
          Boolean(entry.text?.trim())) ||
        entry.kind === 'tool' ||
        entry.kind === 'ui'
    )
  );
}
